import { derived } from 'svelte/store';
import { userInfo } from './user';
const resolveNameDefault = (personaName, namePostfix, dmpSegment, trackingPoint, ageGroups, gender, newDefaultInterests, interestOne, interestTwo, incomeGroups, lastSegmentId = 0, preview = false, mixed = false, clientName) => {
    if (preview) {
        return personaName.replace(/\s/g, '-').replace(/[^\-_\p{L}\p{N}]/gu, '');
    }
    else {
        return personaName.replace(/\s/g, '-').replace(/[^\-_\p{L}\p{N}]/gu, '') + '_' + namePostfix;
    }
};
function getLookalikeNamePart(dmpSegment) {
    if (dmpSegment !== '') {
        return 'LAL-DMP';
    }
    else {
        return 'LAL-TP';
    }
}
const isSocdemoSpecified = (ageGroups, gender) => (ageGroups.length !== 0 && ageGroups.length !== 6) || gender !== null;
const areInterestsSpecified = (newDefaultInterests, interestOne, interestTwo) => newDefaultInterests.length !== 0 || interestOne.value !== '' || interestTwo.value !== '';
const isIncomeSpecified = (incomeGroups) => incomeGroups.length === 1;
function getSocdemInterestIncomeTargetingNamePart(ageGroups, gender, newDefaultInterests, interestOne, interestTwo, incomeGroups) {
    return [
        isSocdemoSpecified(ageGroups, gender) ? 'SOC' : 'NA',
        areInterestsSpecified(newDefaultInterests, interestOne, interestTwo) ? 'INT' : 'NA',
        isIncomeSpecified(incomeGroups) ? 'INC' : 'NA'
    ].join('-');
}
const resolveNameDentsu = (personaName, namePostfix, dmpSegment, trackingPoint, ageGroups, gender, newDefaultInterests, interestOne, interestTwo, incomeGroups, lastSegmentId = 0, preview = false, mixed = false, clientName) => {
    if (!mixed) {
        if (preview) {
            personaName = personaName.replace(/_/g, "-");
            if (dmpSegment !== '' || trackingPoint !== '') {
                return ['DDA', 'CZ', clientName, getLookalikeNamePart(dmpSegment), personaName]
                    .join('_')
                    .replace(/\s/g, '-')
                    .replace(/[^\-_\p{L}\p{N}]/gu, '');
            }
            else {
                return [
                    'DDA',
                    'CZ',
                    clientName,
                    getSocdemInterestIncomeTargetingNamePart(ageGroups, gender, newDefaultInterests, interestOne, interestTwo, incomeGroups),
                    personaName
                ]
                    .join('_')
                    .replace(/\s/g, '-')
                    .replace(/[^\-_\p{L}\p{N}]/gu, '');
            }
        }
        else {
            return (personaName.replace(/\s/g, '-').replace(/[^\-_\p{L}\p{N}]/gu, '') + '_' + 'ds' + lastSegmentId);
        }
    }
    else {
        if (preview) {
            return ['DDA', 'CZ', clientName, 'MIX', personaName]
                .join('_')
                .replace(/\s/g, '-')
                .replace(/[^\-_\p{L}\p{N}]/gu, '');
        }
        else {
            return (personaName.replace(/\s/g, '-').replace(/[^\-_\p{L}\p{N}]/gu, '') + '_' + 'ds' + lastSegmentId);
        }
    }
};
const clientsWebData = [
    {
        name: 'demo_client',
        appTitle: 'AdPicker',
        logoSrc: '/assets/icons/android-chrome-512x512.png',
        logoWidth: '60%',
        primaryColor: '#ef4a50',
        secondaryColor: '#ef4a50',
        logoMarginTop: '16px',
        nameFunc: resolveNameDefault,
        nameEnd: '_demo',
        default: true,
        twoFields: false
    },
    {
        name: 'alza_cz',
        appTitle: 'Alza',
        logoSrc: '/assets/images/clients/alza_cz_logo.png',
        logoWidth: '90%',
        primaryColor: '#0e3267',
        secondaryColor: '#0e3267',
        nameFunc: resolveNameDefault,
        nameEnd: '_alza',
        default: true,
        twoFields: false
    },
    {
        name: 'dentsu_cz',
        appTitle: 'Dentsu CZ',
        logoSrc: '/assets/images/clients/dentsu_logo.svg',
        logoWidth: '90%',
        primaryColor: '#66548F',
        secondaryColor: '#8e9197',
        nameFunc: resolveNameDentsu,
        nameEnd: '_ds000',
        default: false,
        twoFields: true
    },
    {
        name: 'dentsu_at',
        appTitle: 'Dentsu AT',
        logoSrc: '/assets/images/clients/dentsu_logo.svg',
        logoWidth: '90%',
        primaryColor: '#66548F',
        secondaryColor: '#8e9197',
        nameFunc: resolveNameDefault,
        nameEnd: '_dtat',
        default: true,
        twoFields: false
    },
    {
        name: 'cheil_cz',
        appTitle: 'Cheil',
        logoSrc: '/assets/images/clients/cheil_logo.svg',
        logoWidth: '90%',
        primaryColor: '#000000',
        secondaryColor: '#000000',
        nameFunc: resolveNameDefault,
        nameEnd: '_cheil',
        default: true,
        twoFields: false
    },
    {
        name: 'dentsu_x',
        appTitle: 'Dentsu X',
        logoSrc: '/assets/images/clients/dentsu_logo.svg',
        logoWidth: '90%',
        primaryColor: '#66548F',
        secondaryColor: '#8e9197',
        nameFunc: resolveNameDentsu,
        nameEnd: '_ds000',
        default: false,
        twoFields: true
    }
];
const userClientData = derived(userInfo, ($user) => {
    const webData = $user.client
        ? clientsWebData.find((item) => item.name === $user.client.label) || clientsWebData[0]
        : clientsWebData[0];
    return {
        client: $user.client,
        webData
    };
});
export { userClientData };
